const cookieBar = document.querySelector(".cookie-bar")
const cookieBarToggle = document.querySelector(".js--cookie-modal-toggle");

let cookieBarChangePreferences, cookieBarDefaultSettings;
if (cookieBar) {
    cookieBarChangePreferences = cookieBar.querySelector(".js-change-preferences")
    cookieBarDefaultSettings = cookieBar.querySelector(".js-default-settings")
}

if (cookieBar && cookieBarToggle && cookieBarChangePreferences && cookieBarDefaultSettings) {
    cookieBarToggle.addEventListener("click", e => {
        e.preventDefault();
        cookieBar.classList.add("open");
        cookieBar.classList.add("active")
        cookieBarChangePreferences.classList.remove("active")
        cookieBarDefaultSettings.classList.add("active")
    });
}

if (cookieBar && cookieBarChangePreferences && cookieBarDefaultSettings) {
    const cookieBarDefaultOption = cookieBar.querySelector(".js-default-option")

    cookieBarChangePreferences.addEventListener("click", () => {
        cookieBar.classList.add("active")
        cookieBarChangePreferences.classList.remove("active")
        cookieBarDefaultSettings.classList.add("active")
    })

    cookieBarDefaultSettings.addEventListener("click", () => {
        cookieBarDefaultOption.checked = true
    })
}
